import { render } from "./LogoFlag.vue?vue&type=template&id=359d50cc"
import script from "./LogoFlag.vue?vue&type=script&lang=js"
export * from "./LogoFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/branding/LogoFlag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "359d50cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('359d50cc', __exports__)) {
    api.reload('359d50cc', __exports__)
  }
  
  module.hot.accept("./LogoFlag.vue?vue&type=template&id=359d50cc", () => {
    api.rerender('359d50cc', render)
  })

}


export default __exports__